<template>
  <div class="template-data-tree"
       :class="{'main-top-layout': topRoute}"
       v-loading="tree.loading"
       element-loading-text="页面加载中，请稍等...">
    <div class="data-tree">
      <el-card shadow="never" v-if="tree.items">
        <div class="data-tree-content" :class="{'collapsed': tree.collapsed}">
          <div class="data-tree-pane layout-animate">
            <AppScrollbar style="height: 100%">
              <el-menu :default-active="tree.current" @select="handleTreeItemSelect">
                <el-menu-item v-for="(item, index) in tree.items"
                              :key="'data-tree-' + index"
                              :index="item.name">
                  <!--<i :class="item.icon"></i>-->
                  <span slot="title">{{item.label}}</span>
                </el-menu-item>
              </el-menu>
            </AppScrollbar>
          </div>
          <div class="data-tree-router layout-animate">
            <RouteKeepAlive :route-matches="tabItemIds"></RouteKeepAlive>
          </div>
        </div>
      </el-card>
      <template v-else>
        <Hint class="tree-load-failed" :icon="false" v-if="!tree.loading">
          <span>页面加载失败</span>
          <div class="button-group">
            <el-button type="primary" size="mini" plain @click="loadTreeData">点击重试</el-button>
          </div>
        </Hint>
      </template>
    </div>
  </div>
</template>

<script>
import RouteKeepAlive from '../elements/route/RouteKeepAlive'
import AppScrollbar from '../elements/AppScrollbar'
import baseApiUrl from '../../constants/baseApiUrl'
import routeConfig from '../../constants/routeConfig'
import routeUtils from '../../util/routeUtils'
import fragmentUtils from '../../util/fragmentUtils'
import Support from '../../mixins/support'
import Hint from '../elements/Hint'
export default {
  mixins: [Support],
  name: 'TemplateDataTree',
  components: {RouteKeepAlive, AppScrollbar, Hint},
  data () {
    return {
      tree: {
        loading: false,
        loaded: false,
        title: null,
        collapsed: false,
        items: null,
        current: ''
      }
    }
  },
  computed: {
    tabItemIds: function () {
      let items = this.tree.items
      if (items) {
        return items.map(item => item.name)
      } else {
        return null
      }
    }
  },
  methods: {
    toggleTreeMenuView () {
      this.tree.collapsed = !this.tree.collapsed
    },
    handleTreeItemSelect (key, keyPath) {
      this.openTreeItem(key)
    },
    openTreeItem (key) {
      let items = this.tree.items
      if (items) {
        let openItem = items.find(item => item.name === key)
        if (openItem) {
          let $route = this.$route
          let currentPath = routeUtils.getCurrentRoutePath(this, $route)
          let forwardPath = currentPath + (fragmentUtils.resolvePath(openItem.name) || openItem.path)
          // 防止上层跳转时回退
          if ($route.path.startsWith(forwardPath + '/')) {
            return
          }
          let matchId = routeUtils.getRouteMatchId(this, $route)[0]
          if (matchId !== openItem.name) {
            if (currentPath.startsWith($route.path)) {
              this.$router.replace({ path: forwardPath })
            } else {
              this.$router.push({ path: forwardPath })
            }
          }
        }
      }
    },
    loadTreeData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataTree.param]) {
        return
      }
      this.tree.loading = true
      this.$ajax({
        url: baseApiUrl.DataTreeUrl,
        method: 'post',
        data: this.$qs.stringify(postParams, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          // 初始化
          this.tree.title = response.data['title']
          this.tree.collapsed = response.data['collapsed']
          let items = response.data['items']
          this.tree.items = items
          // 如果没有默认的选项
          if (!this.tree.current) {
            let matchId = routeUtils.getRouteMatchId(this, this.$route)[0]
            if (matchId) {
              this.tree.current = matchId
            } else {
              this.tree.current = response.data['current'] || (items && items.length > 0 ? items[0].name : null)
            }
            this.openTreeItem(this.tree.current)
          }
        }
      }).finally(() => {
        this.tree.loading = false
        this.tree.loaded = true
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let matchId = routeUtils.getRouteMatchId(vm, to)[0]
      if (matchId) {
        vm.tree.current = matchId
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    let matchId = routeUtils.getRouteMatchId(this, to)[0]
    if (matchId) {
      next()
      this.$nextTick(() => {
        if (this.tree.items && this.tree.items.some(item => item.name === matchId)) {
          this.tree.current = matchId
        }
      })
    } else {
      if (routeUtils.getCurrentRoutePath(this, to) === routeUtils.getCurrentRoutePath(this, from)) {
        next(false)
      } else {
        next()
      }
    }
  },
  mounted () {
    this.loadTreeData()
  },
  activated () {
    if (this.tree.loaded) {
      if (this.tree.items) {
        this.openTreeItem(this.tree.current)
      } else {
        this.loadTreeData()
      }
    }
  }
}
</script>

<style lang="scss">
  .template-data-tree {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    &.main-top-layout {
      padding: 10px;
    }
    & > .data-tree {
      position: relative;
      height: 100%;
      & > .el-card {
        position: relative;
        height: 100%;
        border-radius: 0;
        border: none;
        background-color: transparent;
        & > .el-card__body {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          bottom: 0;
          padding: 0;
          .data-tree-content {
            position: relative;
            height: 100%;
            &.collapsed {
              & > .data-tree-pane {
                left: -200px;
              }
              & > .data-tree-router {
                left: 0;
              }
            }
            & > .data-tree-pane {
              position: absolute;
              left: 0;
              top: 0;
              width: 180px;
              height: 100%;
              background-color: #fff;
              box-sizing: border-box;
              z-index: 1;
              .el-scrollbar {
                .el-menu {
                  padding-top: 6px;
                  padding-bottom: 6px;
                  background-color: transparent;
                  border-right: none;
                  .el-menu-item,
                  .el-submenu__title {
                    margin-top: 4px;
                    margin-bottom: 4px;
                    height: 32px;
                    font-size: 12px;
                    line-height: 32px;
                    &.is-active,
                    &:hover {
                      background-color: transparent;
                    }
                    &:focus {
                      background-color: transparent;
                    }
                    i {
                      margin-right: 0!important;
                      transform: scale(0.9);
                      &.el-submenu__icon-arrow {
                        font-size: 12px!important;
                      }
                    }
                  }
                  .el-menu-item {
                    position: relative;
                    &:after {
                      content: '';
                      position: absolute;
                      left: 0;
                      top: 0;
                      bottom: 0;
                      width: 2px;
                    }
                  }
                }
              }
            }
            & > .data-tree-router {
              position: absolute;
              left: 190px;
              top: 0;
              right: 0;
              bottom: 0;
              overflow: hidden;
            }
          }
        }
      }
      .tree-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 5px 12px;
            border-radius: 0;
          }
        }
      }
    }
  }
</style>
